import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRealtime } from '../contexts/RealtimeContext';
import { getUserRole, ROLES } from '../utils/rbac';

/**
 * Force redirect for teachers who end up on student dashboard
 * This is a failsafe component
 */
const ForceTeacherRedirect = () => {
  const { currentUser, userProfile } = useRealtime();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser || !userProfile) return;

    const userRole = getUserRole(userProfile, currentUser);
    
    if (userRole === ROLES.TEACHER) {
      console.log('🚨 ForceTeacherRedirect: Teacher detected on wrong page, forcing redirect...');
      
      // Force redirect immediately
      window.location.href = '/teacher/dashboard';
    }
  }, [currentUser, userProfile, navigate]);

  // If we're still here and user is a teacher, show a manual button
  if (currentUser && userProfile) {
    const userRole = getUserRole(userProfile, currentUser);
    
    if (userRole === ROLES.TEACHER) {
      return (
        <div className="fixed top-4 right-4 z-50 bg-red-500 text-white p-4 rounded-lg shadow-lg">
          <p className="font-bold mb-2">⚠️ Wrong Dashboard Detected</p>
          <p className="text-sm mb-3">You're a teacher but seeing student dashboard</p>
          <button
            onClick={() => window.location.href = '/teacher/dashboard'}
            className="bg-white text-red-500 px-4 py-2 rounded font-bold hover:bg-gray-100"
          >
            Go to Teacher Dashboard
          </button>
        </div>
      );
    }
  }

  return null;
};

export default ForceTeacherRedirect;
